export enum OrderOutputFormat {
  CODE_ORDER_OUTPUT_FORMAT_STANDARD = 'STANDARD',
  CODE_ORDER_OUTPUT_FORMAT_WITH_SKU = 'WITH_SKU',
  CODE_ORDER_OUTPUT_FORMAT_AGGREGATED_GS1 = 'GS1',
  CODE_ORDER_OUTPUT_FORMAT_UNIT_GS1_LINK = 'GS1_LINK'
}
